module.exports = __webpack_public_path__ + "img/whitelist2x.png?4f861689d1ba067d09ac9a4a4b18a2ad";